module.exports = __webpack_public_path__ + "static/media/palette-gradient.beb77779.svg";